import Helper from '@ember/component/helper';
import { isArray } from '@ember/array';
import { service } from '@ember/service';
import { capitalize as capitalizeString } from '@ember/string';
import ProgressionJudgement from '@linc-technologies/linced-common/enums/progression-judgement';

export default class ProgressionJudgementLabel extends Helper {
  @service
  strings;

  compute(params, options) {
    if (!isArray(params) || params.length < 1) {
      // No positional param passed; return an empty string.
      return '';
    }

    return getProgressionJudgementLabel(params[0], options, this.strings);
  }
}

export function getProgressionJudgementLabel(
  judgement,
  { capitalize },
  strings,
) {
  let label = '';

  switch (judgement) {
    case ProgressionJudgement.WELL_BELOW:
      label = strings.progressWellBelow;
      break;
    case ProgressionJudgement.BELOW:
      label = strings.progressBelow;
      break;
    case ProgressionJudgement.AT:
      label = strings.progressAt;
      break;
    case ProgressionJudgement.ABOVE:
      label = strings.progressAbove;
      break;
    case ProgressionJudgement.WELL_ABOVE:
      label = strings.progressWellAbove;
      break;
  }

  if (capitalize) {
    label = capitalizeString(label);
  }

  return label;
}
